import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { MoneyValue, NoValue } from '~/modules/common/components';
import { getRoundedValue } from '~/modules/billing-invoicing/common/enhancers';

export const MoneyFormatter = ({ field, record }) => {
  const money = useMemo(
    () =>
      record[field] && {
        ...record[field],
        amount: getRoundedValue(record[field].amount, 2) || 0
      },
    [field, record]
  );

  return money ? <MoneyValue money={money} /> : <NoValue />;
};

MoneyFormatter.propTypes = {
  field: PropTypes.string,
  record: PropTypes.object
};

export default MoneyFormatter;
